import SodReviewModal from './SodReviewModal';

export default SodReviewModal;
